import { render, staticRenderFns } from "./SingleDocumentInput.vue?vue&type=template&id=0d61127c"
import script from "./SingleDocumentInput.vue?vue&type=script&lang=js"
export * from "./SingleDocumentInput.vue?vue&type=script&lang=js"
import style0 from "./SingleDocumentInput.vue?vue&type=style&index=0&id=0d61127c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports